import { Entity } from '@backstage/catalog-model';
import { useEntity } from '@backstage/plugin-catalog-react';
import useAsync from 'react-use/lib/useAsync';
import { ReactNode } from 'react';
import { ErrorPanel } from '@backstage/core-components';

export const Show = (props: {
  if: (entity: Entity) => boolean | Promise<boolean>;
  children: ReactNode;
}) => {
  const { entity } = useEntity();
  const { if: func, children } = props;
  const {
    loading,
    error,
    value: show,
  } = useAsync(() => {
    return Promise.resolve(func(entity));
  }, [func, children]);
  if (error) {
    return <ErrorPanel error={error} />;
  }
  return !loading && show ? children : null;
};
